// src/components/Popup.tsx
import React, { useState, useEffect } from 'react';

interface PopupProps {
  message: string;
  onConfirm: () => void;
}

const Popup: React.FC<PopupProps> = ({ message, onConfirm }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false); // 닫힘 애니메이션 상태

  useEffect(() => {
    const hidePopupUntil = localStorage.getItem('hidePopupUntil');
    const now = new Date().getTime();

    if (!hidePopupUntil || now > Number(hidePopupUntil)) {
      setIsVisible(true);
    }
  }, []);

  const handleHideFor24Hours = () => {
    const now = new Date().getTime();
    const hideUntil = now + 24 * 60 * 60 * 1000;
    localStorage.setItem('hidePopupUntil', hideUntil.toString());
    startCloseAnimation();
  };

  const handleClose = () => {
    startCloseAnimation();
    onConfirm();
  };

  const startCloseAnimation = () => {
    setIsClosing(true);
    setTimeout(() => setIsVisible(false), 300); // 애니메이션 시간과 맞춤
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-[29999]">
      <div className='px-[24px]'>
        <div
          className={`bg-white rounded-lg max-w-[500px] w-full shadow-lg transform transition-transform ${
            isClosing ? 'animate-fadeOut' : 'animate-fadeIn'
          }`}
        >
          <img src={`${process.env.PUBLIC_URL}/popip.png`} alt="Popup" />
          <div className="flex items-center justify-between mt-4 font-normal text-[#000] text-sm">
            <div className="pl-5 pb-4">
              <span
                className="cursor-pointer hover:underline"
                onClick={handleHideFor24Hours}
              >
                오늘 하루 열지 않음
              </span>
            </div>
            <div className="pr-5 pb-4">
              <span
                className="cursor-pointer hover:underline"
                onClick={handleClose}
              >
                닫기
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
